import { inject, Injectable } from "@angular/core";

import type { BaseFilterDefinition, FilterValue } from "@filter/filter.types";
import type { IBaseT1Card, TranslateObject } from "@app/views-interfaces";
import { CategoriesService } from "@shared/categories-service";
import { DashboardsService } from "@shared/dashboards-service";
import { SimpleFilterMulti } from "./types/simple-filter-multi";

const unassignedCategory = "Unassigned";

@Injectable()
export class CategoryFilterService extends SimpleFilterMulti<IBaseT1Card> {
    private readonly categoriesService = inject(CategoriesService);
    private readonly dashboardsService = inject(DashboardsService);

    protected getDefinitionInfo(): BaseFilterDefinition {
        return {
            filterName: "Category",
            label: "AllView.Category",
        };
    }

    protected getValue(item: IBaseT1Card): FilterValue | undefined {
        if (item.categoryId === null) return unassignedCategory;
        return this.resolveCategory(item)?.Id;
    }

    protected getLabel(categoryId: string): string | undefined | null | TranslateObject {
        if (categoryId === unassignedCategory) return "General.None";
        return this.categoriesService.getCategory(categoryId)?.Name;
    }

    protected getAllValues(): readonly string[] {
        return [unassignedCategory, ...this.categoriesService.getCategories().flatMap((category) => (category.Id ? [category.Id] : []))];
    }

    private resolveCategory(card: IBaseT1Card) {
        const dashboard = this.dashboardsService.currentDashboard();
        if (!dashboard) return;
        return this.categoriesService.getCardCategory(card, dashboard);
    }
}
